export { createExtensionClient } from "./client.js";
export * from "./ingestion.js";
export * from "./named-queries.js";
//# sourceMappingURL=index.js.map